module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl3-75.3a08252e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl3-75.png
// module id = 3305
// module chunks = 11